import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    TextField,
    Typography,
    Modal,
    Grid,
    Stack,
    Pagination,
    FormControl
} from "@mui/material";

import PurchaseItemsCards from "./PurchaseItemsCards";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { convertDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";

import {
    getFirstDateOfCurrentMonthPayloadFormate,
    getLastDateOfCurrentMonthPayloadFormat,
} from "../../utils/commonUtils";
import { totalPrice } from "../purchase/purFunction";
import { ToDate } from "../../common/toDate";
import PoprchModal from "../payment/popSearch";
import VendorSearchModal from "./VendorSearchModal";
import { addPurchaseOrderFunction } from "./PurchaseOrderCustomApiHandler";
import { addPurchaseOrder } from "./PurchaseOrderApi.js"
import { updatePurchase } from "./purchaseManagmentApi.js";
import { useSelector } from "react-redux";
import { forIn } from "lodash";

export default function AddPuchaseOrder({ modaldata, open, setOpen, setModalData, getAllData }) {
    //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
    // const [search, setSearch] = useState("");


    const struct = {
        // id: 0,
        vendorId: 0,
        date: "",
        validTill: "",
        totalAmount: 0,
        purchaseItems: []
    }
    const [formData, setFormData] = useState({ ...struct });

    const purchaseItemStruct = {
        itemDescription: "",
        quantity: "",
        unitPrice: "",
        cgst: "",
        sgst: "",
        igst: "",
        subTotal: ""
    }

    const [purchaseItem, setPurchaseItem] = useState(purchaseItemStruct)

    const onClose = () => {
        setOpen(false);
        setAddItemError({...AddItemErrorStruct})
        setFormData({ ...struct })
    };

    const validateForm = () => {
        if (formData.vendorId && formData.date && formData.validTill && formData.purchaseItems.length > 0) {
            return true
        }
        else {
            if (!formData.vendorId) {
                Swal.fire({
                    title: "Select Vendor",
                    icon: "warning",

                    ...swalAlertPopProps,
                });
            }
            else if (!formData.date) {
                Swal.fire({
                    title: "Select Date",
                    icon: "warning",

                    ...swalAlertPopProps,
                });
            }
            else if (!formData.validTill) {
                Swal.fire({
                    title: "Select Valid Till Date",
                    icon: "warning",

                    ...swalAlertPopProps,
                });
            }
            else if (!formData.purchaseItems.length > 0) {
                Swal.fire({
                    title: "Add Purchase Items",
                    icon: "warning",

                    ...swalAlertPopProps,
                });
            }
        }
    }

    const [AddItemError, setAddItemError] = useState({
        itemDescription: false,
        quantity: false,
        unitPrice: false
    })

    const AddItemErrorStruct = {
        itemDescription: false,
        quantity: false,
        unitPrice: false
    }

    const validateItem = () => {
        if (purchaseItem.quantity && purchaseItem.unitPrice) {
            return true
        }
        else {
            let newErrors = { ...AddItemError }
            Object.keys(AddItemError).forEach((key)=>{
                if(!purchaseItem[key]){
                    newErrors[key] = true
                }
            })

            setAddItemError(newErrors)
        }
    }

    const userDetail = useSelector((state) => state.reducer.userDetail);

    useEffect(() => {
        if (modaldata && open) {
            let obj = {}
            Object.keys(struct).map((key, index) => {
                obj[key] = modaldata[key]
            })
            console.log("modalData d=== ", modaldata)
            setFormData({
                ...modaldata, purchaseItems: modaldata?.purchaseItems,
                totalAmount: modaldata?.totalAmount,
                vendorId: modaldata?.vendorId,
                id: modaldata?.id,
                validTill: modaldata?.validTill,

            })
            setSearchvalue(modaldata?.vendorName)
            setCardValue({
                vendorId: modaldata?.vendorId,
                vendorName: modaldata?.vendorName
            })
        }
        else {

            setFormData({ ...struct })
            // setSearchvalue(:)
            setModalData(null)
            setPurchaseItem({ ...purchaseItemStruct })
            setCardValue(null)
            setSearchvalue("")

        }
    }, [open])
    useEffect(() => {
        console.log("formDataformData== ", formData)

    }, [formData])
    const [searchModal, setSearchModal] = useState(false);

    const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);
    const [search, setSearchvalue] = useState("");
    const [cardValue, setCardValue] = useState({});

    const [startDateFormat, setstartDateFormat] = useState(
        getFirstDateOfCurrentMonthPayloadFormate()
    );

    const datePickerRef = useRef();

    const openDatePicker = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    useEffect(() => {
        setPurchaseItem({ ...purchaseItem, subTotal: (purchaseItem.unitPrice * purchaseItem.quantity), total: (purchaseItem.unitPrice * purchaseItem.quantity) });
    }, [purchaseItem.unitPrice, purchaseItem.quantity])


    // useEffect(()=>{
    //     setFormData((prev)=>{
    //         let t={...prev}
    //         return {...t, totalAmount:parseFloat( totalPrice(formData.purchaseItems))}
    //     })
    // },[formData])

    useEffect(() => {
        console.log("purchase data businessChooseTab?.value", userDetail)
        if (userDetail && userDetail?.profileId) {
            let val = userDetail?.profileId?.split("?")[1]

            setFormData((prev) => {
                let t = { ...prev }
                return {
                    ...t,
                    totalAmount: parseFloat(totalPrice(formData.purchaseItems)),
                    // billerId:val.split("=")[1]?.replace(/\D/g, "") ,

                }
            })
        }
    }, [userDetail]);
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    background: "white",
                    width: "52%",
                    overflowY: "auto",
                    // height: "90vh",
                    position: "absolute",
                    left: "25%",
                    top: "10%",
                }}
            >
                <ModalHeader title={"Purchase Order"}
                    onClose={(data) => {
                        setOpen(data)
                        setAddItemError({...AddItemErrorStruct})
                    }}
                />
                <Grid container sx={{ position: "relative" }}>

                    <Grid item xs={6} sx={{ p: 0 }}  >
                        <Grid container sx={{ position: "relative" }}>
                            <Grid item xs={12} sx={{ p: "14px" }}>
                                <Box
                                    readonly
                                    fullWidth
                                    onClick={() => {
                                        setSearchOutStandingsModal(true);
                                    }}
                                    sx={{
                                        mt: "12px",
                                        display: "flex",
                                        height: "23px",
                                        justifyContent: "space-between",
                                        // width: "70%",
                                        border: "1px solid #c9c9c9",
                                        p: 1,
                                        borderRadius: "4px ",
                                        color: "grey",
                                        "&:hover": {
                                            cursor: "pointer !important",
                                        },
                                    }}
                                    onChange={(e) => {
                                        // setSearch(e.target.value);
                                    }}
                                >
                                    <Typography variant="p">
                                        {search !== "" ? search : "Search Vendor"}
                                    </Typography>
                                    <SearchIcon
                                        onClick={() => {
                                            setSearchOutStandingsModal(true);
                                        }}
                                        sx={{
                                            color: (theme) => theme.palette.primary.main,
                                            cursor: "pointer",
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={6} sx={{ p: "14px" }}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Date"
                                            value={formData?.date ? dayjs(formData.date) : null}
                                            onChange={(newValue) => {
                                                console.log(newValue)
                                                let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                setFormData({ ...formData, date: formattedDate });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    InputLabelProps={{ className: "mulish" }}
                                                    InputProps={{ classes: { input: "mulish" } }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sx={{ p: "14px" }}>
                                <FormControl fullWidth >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Valid Till"
                                            value={formData?.validTill ? dayjs(formData.validTill) : null}

                                            onChange={(newValue) => {
                                                console.log(newValue)
                                                let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                setFormData({ ...formData, validTill: formattedDate });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    InputLabelProps={{ className: "mulish" }}
                                                    InputProps={{ classes: { input: "mulish" } }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ p: "14px" }}>
                                <TextField
                                    sx={{ width: "100%", mt: "10px" }}
                                    label="item Description "
                                    value={purchaseItem?.itemDescription}
                                    onChange={(e) => {
                                        setAddItemError({...AddItemError, itemDescription: false})
                                        setPurchaseItem({ ...purchaseItem, itemDescription: e.target.value });
                                    }}
                                />
                                {AddItemError.itemDescription && <Typography variant="caption" color="red">Item Description is Required</Typography>}
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    type="text"
                                    label="Quantity"
                                    sx={{ width: "100%" }}
                                    value={purchaseItem?.quantity}
                                    required
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    onChange={(e) => {
                                        setAddItemError({...AddItemError, quantity: false})
                                        setPurchaseItem({ ...purchaseItem, quantity: Number(e.target.value) });
                                    }}
                                />
                                {AddItemError.quantity && <Typography variant="caption" color="red">Quantity is Required</Typography>}
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    type="text"
                                    sx={{ width: "100%" }}
                                    label="Unit Price"
                                    required
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    value={purchaseItem?.unitPrice}
                                    onChange={(e) => {
                                        setAddItemError({...AddItemError, unitPrice: false})
                                        setPurchaseItem({ ...purchaseItem, unitPrice: Number(e.target.value) });
                                    }}
                                />
                                {AddItemError.unitPrice && <Typography variant="caption" color="red">Unit Price is Required</Typography>}
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    type="number"
                                    sx={{ width: "100%" }}
                                    label="Sub Total"
                                    value={purchaseItem?.subTotal}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    label="CGST"
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    value={purchaseItem?.cgst}
                                    onChange={(e) => {
                                        setPurchaseItem({ ...purchaseItem, cgst: Number(e.target.value) });
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    label="IGST"
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    value={purchaseItem?.igst}
                                    onChange={(e) => {
                                        setPurchaseItem({ ...purchaseItem, igst: Number(e.target.value) });
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sx={{ p: "14px" }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    label="SGST"
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                    value={purchaseItem?.sgst}
                                    onChange={(e) => {
                                        setPurchaseItem({ ...purchaseItem, sgst: Number(e.target.value) });
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ p: "14px" }}>
                                <Button
                                    sx={{ width: "100%" }}
                                    variant="contained"
                                    onClick={() => {
                                        if (validateItem()) {
                                            setFormData({ ...formData, purchaseItems: [...formData?.purchaseItems, { ...purchaseItem }] })
                                            // setPurchaseItemsArr([...purchaseItemsArr, { purchaseItem }])
                                            setPurchaseItem({ ...purchaseItemStruct })
                                        }
                                    }}
                                >
                                    Add Item
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={0.5} sx={{ display: "flex", justifyContent: "center" }}>
                        <Box style={{ borderRight: '1px solid #ccc', height: '100%' }} />
                    </Grid>
                    <Grid item xs={5.5} sx={{ pr: 2 }}>
                        <Box
                            sx={{
                                height: "auto",
                                overflowY: "auto",

                            }}
                        >
                            {formData?.purchaseItems?.map((item, index) => {
                                return (
                                    <PurchaseItemsCards
                                        key={index + "purchaseitem"}
                                        index={index}
                                        item={item}
                                        arr={formData}
                                        setFormData={setFormData}
                                    />
                                );
                            })}
                        </Box>
                        <Divider
                            sx={{
                                background: (theme) => theme.palette.primary.main,
                                width: "100%",
                                mt: 1,
                            }}
                        />
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-around'
                        }}>
                            <Typography color="primary">
                                <strong>Total Amount: &nbsp;
                                </strong>
                            </Typography>
                            <Box
                                component="span"
                                sx={{
                                    color: (theme) => theme.palette.secondary.main,
                                }}
                            >
                                {" "}
                                <CurrencyRupeeIcon sx={{ fontSize: "14px" }} />
                                {
                                    totalPrice(formData.purchaseItems)}
                            </Box>
                        </Box>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={async () => {
                                console.log(formData)

                                if (validateForm()) {
                                    if (modaldata) {
                                        await updatePurchase({ ...formData, totalAmount: parseFloat(totalPrice(formData.purchaseItems)) }, (res) => {
                                            if (res?.data?.succeeded) {
                                                Swal.fire({
                                                    title: "Purchase Update Successfully",
                                                    icon: "success",

                                                    ...swalAlertPopProps,
                                                });

                                                getAllData()
                                                setOpen(false)
                                            }
                                            else {
                                                Swal.fire({
                                                    title: res?.data?.message,
                                                    icon: "error",

                                                    ...swalAlertPopProps,
                                                });
                                            }
                                            setFormData({ ...struct })
                                        })
                                    }
                                    else {


                                        await addPurchaseOrderFunction(addPurchaseOrder, { ...formData, totalAmount: parseFloat(totalPrice(formData.purchaseItems)) }, (res) => {
                                            if (res?.data?.succeeded) {
                                                Swal.fire({
                                                    title: "Purchase Added Successfully",
                                                    icon: "success",

                                                    ...swalAlertPopProps,
                                                });
                                                getAllData()
                                                setOpen(false)
                                            }
                                            else {
                                                Swal.fire({
                                                    title: res?.data?.message,
                                                    icon: "error",

                                                    ...swalAlertPopProps,
                                                });
                                            }

                                            setFormData({ ...struct })
                                        })
                                    }
                                }
                            }}
                        >
                            {modaldata ? 'Update' : "Submit"}
                        </Button>
                    </Grid>
                </Grid>
                <VendorSearchModal
                    cardValue={cardValue}
                    setCardValue={(data) => {
                        setSearchvalue(data?.vendorName);
                        console.log("id id id== ", data)
                        setCardValue(data);
                        setFormData({ ...formData, vendorId: data?.id })
                    }}
                    callback={() => { }}
                    searchModal={!!searchOutStandingsModal} // Ensure it's a boolean
                    setSearchModal={setSearchOutStandingsModal} // Ensure proper function
                />
            </Box>

        </Modal >
    );
}
